<template>
  <div v-if="showInitialLoading">
    <div id="loading-grid">
      <svg
        class="spinner"
        width="65px"
        height="65px"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          class="path"
          fill="none"
          stroke-width="6"
          stroke-linecap="round"
          cx="33"
          cy="33"
          r="30"
        ></circle>
      </svg>
    </div>
  </div>
  <div
    v-else
    v-bind:id="uniqueId"
    :class="
      showOverlayLoading
        ? 'opacity-75  loadingGrid hover:pointer-events-none cursor-wait'
        : ''
    "
  >
    <div :class="tableContainerClasses">
      <div class="vx-row mb-2">
        <div class="vx-col lg:w-1/3 w-full">
          <label class="vs-select--label">نام دسترسی</label>
          <vs-input
            name="user"
            v-model="permissionName"
            @keyup.enter="searchPermission(permissionName)"
          />
        </div>
        <div class="vx-col lg:w-1/6 w-full">
          <vs-button
            class="mt-6 p-2"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-search"
            @click.prevent="searchPermission(permissionName)"
          ></vs-button>
        </div>
        <div class="vx-col lg:w-1/2 w-full">
          <vs-button
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-plus"
            class="mx-3 mt-4 float-right"
            @click.prevent="createPermission()"
            >ایجاد شاخه اصلی</vs-button
          >
        </div>
      </div>
      <div class="con-tablex vs-table--content">
        <div class="vs-con-tbody vs-table--tbody">
          <table class="vs-table vs-table--tbody-table">
            <thead class="vs-table--thead">
              <template style="display: flex">
                <tr style="width: 100% !important">
                  <th style="width: 50%; text-align: center">عنوان فارسی</th>
                  <th style="width: 20%; text-align: center">عنوان انگلیسی</th>
                  <th style="width: 10%; text-align: center">وضعیت</th>
                  <th style="width: 20%; text-align: center">عملیات</th>
                </tr>
              </template>
            </thead>
            <tbody class="list" v-for="i in rowItems" :key="i.id" ref="total">
              <template>
                <tr :class="i.__tableRowClass">
                  <td @click="onShowChildren(i)">
                    <div class="cursor-pointer flex items-center px-2 gap-2">
                      <template v-if="i.children.length">
                        <feather-icon
                          v-if="i.hasChildren"
                          icon="ChevronDownIcon"
                          style="width: 1rem; height: 1rem"
                        ></feather-icon>
                        <feather-icon
                          v-else
                          icon="ChevronLeftIcon"
                          style="width: 1rem; height: 1rem"
                        ></feather-icon>
                      </template>
                      <span :id="i.name" class="">{{ i.persianName }}</span>
                    </div>
                  </td>
                  <td>{{ i.name }}</td>
                  <slot :row="i" :index="i.id">
                    <td
                      v-for="(c, cIndex) in columns"
                      :key="cIndex"
                      v-html="renderCell(c, i)"
                    ></td>
                  </slot>
                </tr>
                <template v-for="firstChild in i.children">
                  <tr
                    v-show="i.hasChildren"
                    v-if="i.children"
                    :key="firstChild.id"
                    :class="i.__tableRowClass"
                    style="
                      background-color: rgba(200, 200, 200, 0.3) !important;
                    "
                  >
                    <td
                      style="
                        text-align: right;
                        padding: 1% 7%;
                        display: flex;
                        margin: 0.5% 0;
                      "
                      @click="onShowChildren(firstChild)"
                    >
                      <div class="cursor-pointer flex items-center px-2 gap-2">
                        <template v-if="firstChild.children.length">
                          <feather-icon
                            v-if="firstChild.hasChildren"
                            icon="ChevronDownIcon"
                            style="width: 1rem; height: 1rem"
                          ></feather-icon>
                          <feather-icon
                            v-else
                            icon="ChevronLeftIcon"
                            style="width: 1rem; height: 1rem"
                          ></feather-icon>
                        </template>
                        <span :id="firstChild.name">
                          {{ firstChild.persianName }}
                        </span>
                      </div>
                    </td>
                    <td>{{ firstChild.name }}</td>
                    <slot :row="firstChild" :index="firstChild">
                      <td
                        v-for="(c, cIndex) in columns"
                        :key="cIndex"
                        v-html="renderCell(c, firstChild)"
                      ></td>
                    </slot>
                  </tr>
                  <template v-for="secondChild in firstChild.children">
                    <tr
                      v-show="firstChild.hasChildren"
                      v-if="firstChild.children"
                      :key="secondChild.id"
                      style="
                        background-color: rgba(200, 200, 200, 0.7) !important;
                      "
                      :class="i.__tableRowClass"
                    >
                      <td
                        style="
                          padding: 1% 14%;
                          text-align: right;
                          display: flex;
                          margin: 0.5% 0;
                        "
                        @click="onShowChildren(secondChild)"
                      >
                        <div
                          class="cursor-pointer flex items-center px-2 gap-2"
                        >
                          <template v-if="secondChild.children.length">
                            <feather-icon
                              v-if="secondChild.hasChildren"
                              icon="ChevronDownIcon"
                              style="width: 1rem; height: 1rem"
                              class="cursor-pointer"
                            ></feather-icon>
                            <feather-icon
                              v-else
                              icon="ChevronLeftIcon"
                              style="width: 1rem; height: 1rem"
                              class="cursor-pointer"
                            ></feather-icon>
                          </template>
                          <span :id="secondChild.name">
                            {{ secondChild.persianName }}
                          </span>
                        </div>
                      </td>
                      <td>{{ secondChild.name }}</td>
                      <slot :row="secondChild" :index="secondChild">
                        <td
                          v-for="(c, cIndex) in columns"
                          :key="cIndex"
                          v-html="renderCell(c, secondChild)"
                        ></td>
                      </slot>
                    </tr>
                    <template v-for="thirdChild in secondChild.children">
                      <tr
                        v-show="secondChild.hasChildren"
                        v-if="secondChild.children"
                        :key="thirdChild.id"
                        style="
                          background-color: rgba(200, 200, 200, 1) !important;
                        "
                        :class="i.__tableRowClass"
                      >
                        <td
                          style="
                            padding: 1% 21%;
                            text-align: right;
                            display: flex;
                            margin: 0.5% 0;
                          "
                          @click="onShowChildren(thirdChild)"
                        >
                          <template v-if="thirdChild.children.length">
                            <feather-icon
                              v-if="thirdChild.hasChildren"
                              icon="ChevronDownIcon"
                              style="width: 1rem; height: 1rem"
                              class="cursor-pointer"
                            ></feather-icon>
                            <feather-icon
                              v-else
                              icon="ChevronLeftIcon"
                              style="width: 1rem; height: 1rem"
                              class="cursor-pointer"
                            ></feather-icon>
                          </template>
                          <label :id="thirdChild.name" class="mx-2">
                            {{ thirdChild.persianName }}
                          </label>
                        </td>
                        <td>{{ thirdChild.name }}</td>
                        <slot :row="thirdChild" :index="thirdChild">
                          <td
                            v-for="(c, cIndex) in columns"
                            :key="cIndex"
                            v-html="renderCell(c, thirdChild)"
                          ></td>
                        </slot>
                      </tr>
                    </template>
                  </template>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
#div-loading .con-vs-loading {
  position: unset !important;
  margin: 0 auto;
  display: initial;
}

#div-loading .con-vs-loading .vs-loading {
  margin: 0 auto;
  display: inline-flex;
  width: 100%;
}
.textInSearch {
  color: #007470 !important;
  font-weight: bold;
}
</style>
<style scoped>
.loadingGrid {
  filter: grayscale(100%) blur(2px) !important;
}
</style>
<script>
import { ajax } from "@/plugins/ajax";
import utils from "@/assets/utils/index";
import "../../assets/scss/vuesax-rtl/_grid-style.scss";

export default {
  name: "tree-grid",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },

    dataSource: {
      type: Object,
      default: () => ({
        type: "",
        url: "",
        method: "get",
        service: "",
        transform: null,
        data: null,
      }),
    },

    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: true,
    },
    hover: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    tableContainerClasses() {
      var classes = "datagrid vs-component vs-con-table vs-table-primary";
      if (this.striped === true) classes += " stripe";
      if (this.bordered === true) classes += " table-bordered";
      if (this.hover === true) classes += " table-hover";
      return classes;
    },
  },
  data() {
    var uniqueId = "dt_" + utils.randomString(8);
    return {
      uniqueId: uniqueId,
      rowItems: [],
      showInitialLoading: false,
      showOverlayLoading: false,
      errorOccurred: false,
      permissionName: "",
      itWasInSearch: false,
    };
  },
  mounted() {
    this.renderGrid({ showOverlayLoading: false });
  },
  methods: {
    scrollToTargetAdjusted(element) {
      const offset = 140;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    },
    searchPermission(i) {
      if (i.length && i.length > 2) {
        this.itWasInSearch = false;
        this.falseHasChildrenForSearch(this.rowItems);
        let scrolledToFirstElement = false;
        for (let index = 0; index < this.rowItems.length; index++) {
          if (this.rowItems[index].children.length) {
            let currentFirstParent = this.rowItems[index];
            for (
              let index1 = 0;
              index1 < currentFirstParent.children.length;
              index1++
            ) {
              if (
                currentFirstParent.children[index1].persianName.includes(i) ||
                currentFirstParent.children[index1].name.includes(i)
              ) {
                currentFirstParent.hasChildren = true;
                this.itWasInSearch = true;
                let element = document.getElementById(
                  currentFirstParent.children[index1].name
                );
                element.classList.add("textInSearch");
                if (!scrolledToFirstElement) {
                  setTimeout(() => {
                    this.scrollToTargetAdjusted(element);
                  }, 200);
                  scrolledToFirstElement = true;
                }
              }
              if (currentFirstParent.children[index1].children.length) {
                let currentSecondParent = currentFirstParent.children[index1];
                for (
                  let index2 = 0;
                  index2 < currentSecondParent.children.length;
                  index2++
                ) {
                  if (
                    currentSecondParent.children[index2].persianName.includes(
                      i
                    ) ||
                    currentSecondParent.children[index2].name.includes(i)
                  ) {
                    currentFirstParent.hasChildren = true;
                    currentSecondParent.hasChildren = true;
                    this.itWasInSearch = true;
                    let element = document.getElementById(
                      currentSecondParent.children[index2].name
                    );
                    if (!scrolledToFirstElement) {
                      setTimeout(() => {
                        this.scrollToTargetAdjusted(element);
                      }, 200);
                      scrolledToFirstElement = true;
                    }
                    element.classList.add("textInSearch");
                  }

                  if (currentSecondParent.children[index2].children.length) {
                    let currentThridParent =
                      currentSecondParent.children[index2];
                    for (
                      let index3 = 0;
                      index3 < currentThridParent.children.length;
                      index3++
                    ) {
                      if (
                        currentThridParent.children[
                          index3
                        ].persianName.includes(i) ||
                        currentThridParent.children[index3].name.includes(i)
                      ) {
                        currentFirstParent.hasChildren = true;
                        currentSecondParent.hasChildren = true;
                        currentThridParent.hasChildren = true;
                        this.itWasInSearch = true;
                        let element = document.getElementById(
                          currentThridParent.children[index3].name
                        );
                        if (!scrolledToFirstElement) {
                          setTimeout(() => {
                            this.scrollToTargetAdjusted(element);
                          }, 200);

                          scrolledToFirstElement = true;
                        }
                        element.classList.add("textInSearch");
                      }
                    }
                  }
                }
              }
            }
          }
        }
        if (this.itWasInSearch == false) {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "چنین عبارتی پیدا نشد!",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } else {
        this.$swal({
          position: "center-center",
          type: "warning",
          text: "حداقل سه حرف وارد کنید!",
          showConfirmButton: true,
        });
      }
    },
    falseHasChildrenForSearch(r) {
      for (let index = 0; index < r.length; index++) {
        r[index].hasChildren = false;
        let element = document.getElementById(r[index].name);
        if (element) {
          element.classList.remove("textInSearch");
          if (r[index].children.length) {
            this.falseHasChildrenForSearch(r[index].children);
          }
        }
      }
    },
    loopForChildren(i, v) {
      if (i.children) {
        for (let index = 0; index < i.children.length; index++) {
          if (v == 1) {
            i.children[index].hasChildren = false;
            this.loopForChildren(i.children[index], 1);
          }
        }
      }
    },
    onShowChildren(i) {
      i.hasChildren = !i.hasChildren;
      if (!i.hasChildren) {
        this.loopForChildren(i, 1);
      }
    },
    renderGrid(renderConfig) {
      var self = this;
      if (renderConfig.showOverlayLoading) {
        this.showOverlayLoading = true;
      } else {
        this.showInitialLoading = true;
      }
      this.getData()
        .then((result) => {
          this.showOverlayLoading = false;
          this.showInitialLoading = false;
          self.rowItems = result;
          if (renderConfig.searchKeyword)
            this.searchPermission(renderConfig.searchKeyword);
        })
        .catch(() => {
          this.showOverlayLoading = false;
          this.showInitialLoading = false;
        });
    },
    renderCell(columnItem, rowItem) {
      return rowItem[columnItem.field];
    },
    getData() {
      var self = this;
      return new Promise((resolve, reject) => {
        if (this.dataSource) {
          var getDataFromResourcePromise = self.getDataFromAppService();
          getDataFromResourcePromise
            .then((result) => {
              if (
                this.dataSource.transform &&
                utils.isFunction(this.dataSource.transform)
              )
                result = this.dataSource.transform(result);
              resolve(result);
            })
            .catch((e) => {
              reject(e);
            });
        } else {
          reject();
          this.errorOccurred = true;
        }
      });
    },

    getDataFromAppService() {
      var self = this;
      return new Promise((resolve, reject) => {
        ajax[self.dataSource.method || "get"](self.dataSource.service)
          .then((r) => {
            if (r) {
              resolve(r.data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
            this.errorOccurred = true;
          });
      });
    },
    createPermission() {
      this.$emit("createPermissionInTree", "");
    },
  },
};
</script>
